import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  card: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardActionArea: {
    width: '100%',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  cardContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gridGap: theme.spacing(2),
    paddingInline: theme.spacing(2),
    minHeight: 60,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      padding: theme.spacing(2),
    },
  },
  titleContainer: {
    flexGrow: 1,
    overflow: 'hidden',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  archivedChip: {
    color: theme.palette.statusLabel.warning.primary,
    borderColor: theme.palette.statusLabel.warning.primary,
  },
}))

export default styles
